import { Dialog } from '@m/alchemy-ui/Dialog';
import { DeleteIcon } from '@m/alchemy-ui/icons/DeleteIcon';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { type RemoveButtonProps } from '../../features';
import { DeleteIconButton } from './DeleteIconButton';

export const RemoveButton = ({ onClick }: RemoveButtonProps) => {
  const intl = useIntl();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirm = () => {
    if (onClick) onClick();
    setConfirmOpen(false);
  };

  return (
    <>
      <DeleteIconButton onClick={() => setConfirmOpen(true)} icon={<DeleteIcon aria-label="Remove" />} />
      <Dialog
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        headerContent={intl.formatMessage({ id: 'areYouSure', defaultMessage: 'Are you sure?' })}
        bodyContent={intl.formatMessage({
          id: 'messageDeleteConfirmation',
          defaultMessage: 'Are you sure? Your copy of this conversation will be deleted'
        })}
        isConstrainedToPortalRoot
        footerButtons={[
          {
            label: intl.formatMessage({ id: 'cancel', defaultMessage: 'Cancel' }),
            onClick: () => setConfirmOpen(false),
            priority: 'tertiary'
          },
          {
            label: intl.formatMessage({ id: 'delete', defaultMessage: 'Delete' }),
            onClick: handleConfirm,
            destructive: true
          }
        ]}
      />
    </>
  );
};
